<app-main-page>
  <app-transactions-list></app-transactions-list>
</app-main-page>
